import React from "react";

const PrivateBatchPage = () => {
  return <h1>Create a Private Batch Page</h1>;
};

export default PrivateBatchPage;
